import { Component, Input, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { ICerere } from '../../cereri.interface';
import { formConfigurations, matrimonialRegimes, militaryRanks, militaryStatuses } from './informatii-aditionale';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import Swal from 'sweetalert2';
import { helper } from 'src/environments/helper';
import { CereriService } from '../../cereri.service';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'app-informatii-aditionale',
    templateUrl: './informatii-aditionale.component.html',
    styleUrls: ['./informatii-aditionale.component.scss'],
})
export class InformatiiAditionaleComponent implements OnChanges {
    @Input() cerere!: ICerere;

    helper = helper;

    selectedInfoStatus = 'info';
    selectedChildIndex = 0;

    currentFormFields: Array<{
        label: string;
        value: string;
        type?: string;
    }> = [];

    militaryStatuses = militaryStatuses;
    militaryRanks = militaryRanks;
    matrimonialRegimes = matrimonialRegimes;

    constructor(private cereriService: CereriService, public permissionsService: PermissionsService) { }

    onInfoChange(event: MatButtonToggleChange) {
        this.selectedInfoStatus = event.value;
    }

    onChildChange(index: number) {
        this.selectedChildIndex = index;
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.getCurrentFormFields();
        if (changes['cerere']) {
            let currentSlug = this.cerere?.slug || 'default-slug';

            this.currentFormFields = formConfigurations[currentSlug] || [];
        }
    }

    getCurrentFormFields(): Array<{
        label: string;
        value: string;
        type?: string;
    }> {
        let currentSlug = this.cerere?.slug || 'default-slug';

        const allFields = formConfigurations[currentSlug] || [];

        // Mark checkbox fields
        return allFields.map((field) => {
            return {
                ...field,
                isCheckboxField: field.value.includes('.'),
            };
        });
    }

    mapValueToName(
        controlValue: string | number | null,
        nameValueList: { name: string, value: string }[]
    ) {
        if (controlValue) {
            const status = nameValueList.find(status => status.value === controlValue);
            if (status) {
                return status.name;
            }
        }

        return 'N/A';
    }
}
